import { ContainerParams, ContainerTypes } from '@/types/containerTypes';
import { Container } from './container';

export type ScenarioParams = ContainerParams & {
  isSelected?: boolean;
};

export class Scenario extends Container {
  isSelected: boolean;

  constructor(params: ScenarioParams) {
    super(params);
    this.containerType = ContainerTypes.Scenario;
    this.isSelected = params.isSelected || false;
  } 
}
